function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.2 14.1V1.9c0-.4.3-.8.8-.8s.8.3.8.8v12.2c0 .4-.3.8-.8.8s-.8-.4-.8-.8zm11.2-3.3C24 8.4 21.7 6.5 19 5.6c-.4-.1-.8.1-1 .5-.1.4.1.8.5 1 2.3.8 4.3 2.5 5.6 4.6 1.3 2.1 1.7 4.6 1.3 7.1-.4 2.4-1.7 4.7-3.6 6.3-1.9 1.6-4.3 2.5-6.8 2.5s-4.9-.9-6.8-2.5c-1.9-1.6-3.2-3.8-3.6-6.3s0-5 1.3-7.1S9.2 7.8 11.5 7c.4-.1.6-.6.5-1-.1-.4-.6-.6-1-.5-2.7.9-4.9 2.8-6.4 5.2-1.4 2.4-2 5.3-1.5 8.1s1.9 5.3 4.1 7.1c2.2 1.8 4.9 2.8 7.7 2.8s5.6-1 7.7-2.8c2.2-1.8 3.6-4.4 4.1-7.1.6-2.7.1-5.6-1.3-8z"
})));